import { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { employeesApi } from "../../../api/employeesApi";
import { SingleEmployeeType } from "../../../types/employeeType";
import TimeTrackingPage from "./TimeTrackingPage";

const TimeTrackingEmployeeEntriesPage = () => {
  const { t } = useTranslation();
  const { serviceModuleId, employeeId } = useParams<{ serviceModuleId: string; employeeId: string }>();
  const parsedServiceModuleId = Number(serviceModuleId);
  const [employee, setEmployee] = useState<SingleEmployeeType | null>(null);

  useEffect(() => {
    if (!employeeId) return;
    const fetchEmployee = async () => {
      const result = await employeesApi.getEmployeeById(employeeId);
      if (result.success() && result.result) {
        setEmployee(result.result);
      } else {
        setEmployee(null);
      }
    };
    fetchEmployee();
  }, [employeeId]);

  const title = useMemo(() => {
    if (!employee) {
      return t("serviceModulesPage.timetrackingPage.employeeEntriesTitleFallback");
    }
    return t("serviceModulesPage.timetrackingPage.employeeEntriesTitle", {
      name: `${employee.firstName} ${employee.lastName}`,
    });
  }, [employee, t]);

  const breadcrumbs = useMemo(
    () => [
      {
        title: "serviceModulesPage.serviceModules",
        link: "serviceModules",
      },
      {
        title,
        link: `serviceModules/timetracking/${serviceModuleId}/employee/${employeeId}`,
      },
    ],
    [employeeId, serviceModuleId, title]
  );

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs} title={title} />
      <Box sx={{ mt: 3 }}>
        <TimeTrackingPage
          serviceModuleId={Number(parsedServiceModuleId)}
          hidePageTitle
          fixedEmployeeId={employeeId}
          hideEmployeeFilter
        />
      </Box>
    </>
  );
};

export default TimeTrackingEmployeeEntriesPage;
